import { api } from "./apiClient";

export const requirementsAPI = {
  queryAnswer: (projectId, payload) =>
    api.post(`/projects/${projectId}/requirement-answers/query`, payload, {
      timeout: 240000,
    }),

  listAnswers: (projectId, params = {}) =>
    api.get(`/projects/${projectId}/requirement-answers`, {
      params,
      timeout: 60000,
    }),

  getAnswer: (projectId, answerId) =>
    api.get(`/projects/${projectId}/requirement-answers/${answerId}`, {
      timeout: 60000,
    }),

  refineAnswer: (projectId, answerId, feedback) =>
    api.post(
      `/projects/${projectId}/requirement-answers/${answerId}/refine`,
      { feedback },
      { timeout: 240000 },
    ),

  refreshAnswer: (projectId, answerId) =>
    api.post(
      `/projects/${projectId}/requirement-answers/${answerId}/refresh`,
      null,
      { timeout: 240000 },
    ),

  approveAnswer: (projectId, answerId, note = null) =>
    api.post(`/projects/${projectId}/requirement-answers/${answerId}/approve`, {
      note,
    }),

  rejectAnswer: (projectId, answerId, note = null) =>
    api.post(`/projects/${projectId}/requirement-answers/${answerId}/reject`, {
      note,
    }),

  checklistPreviewFromAnswer: (projectId, answerId, payload) =>
    api.post(
      `/projects/${projectId}/requirement-answers/${answerId}/checklist/preview`,
      payload,
      { timeout: 240000 },
    ),

  saveChecklistFromAnswer: (projectId, answerId, payload) =>
    api.post(
      `/projects/${projectId}/requirement-answers/${answerId}/checklist/save`,
      payload,
      { timeout: 240000 },
    ),

  adminUsage: (params = {}) =>
    api.get("/admin/ai-usage", {
      params,
      timeout: 60000,
    }),
};
